import axios from 'axios';
import isToday from 'date-fns/is_today';

import {
  FETCH_DATA,
  FETCH_DATA_SUCCESS,
  FETCH_DATA_ERROR,
} from './constants';

const dataLayerPush = {
  disconnectService: (success, date, soc, title) => {
    window.dataLayer.push({
      event: success
        ? 'event_item_disconnection_success'
        : 'event_item_disconnection_error',
      profile: '1',
      clientType: 'B2C',
      dateDisconnect: isToday(date) ? 'current' : 'future',
      ordered_itemProduct: 'Мобильная связь',
      ordered_itemCat: 'Services',
      ordered_itemSoc: soc,
      ordered_itemTitle: title,
    });
  },
};

export function fetchDataStart(loadingBlocks) {
  return {
    type: FETCH_DATA,
    loadingBlocks,
  };
}

export function fetchDataSuccess(data) {
  return {
    type: FETCH_DATA_SUCCESS,
    data,
  };
}

export function fetchDataError(error) {
  return {
    error,
    type: FETCH_DATA_ERROR,
  };
}

// TODO: update path to /api/profile/services/data after API refactoring
export function fetchData(blocks) {
  return (dispatch) => {
    dispatch(fetchDataStart(blocks));

    axios.get('/api/profile/userinfo/data/', {
      params: {
        blocks: blocks.join(','),
      },
    }).then((response) => {
      dispatch(fetchDataSuccess(response.data));
    }).catch((error) => {
      dispatch(fetchDataError(error));
    });
  };
}

export function refetchData(block) {
  return (dispatch) => {
    dispatch(fetchDataStart([block]));

    axios.get('/api/profile/userinfo/data/', {
      params: {
        blocks: block,
        noTimeout: true,
      },
    }).then((response) => {
      dispatch(fetchDataSuccess(response.data));
    }).catch((error) => {
      dispatch(fetchDataError(error));
    });
  };
}

export function disconnectService(effDate, soc, title) {
  return () => (
    axios.post('/api/profile/userinfo/deactivateservice/', { effDate, soc })
      .then((response) => {
        dataLayerPush.disconnectService(true, effDate, soc, title);
        return Promise.resolve(response.data);
      })
      .catch((response) => {
        dataLayerPush.disconnectService(false, effDate, soc, title);
        return Promise.reject(response.data);
      })
  );
}

export function disconnectSubscription(id, type) {
  return () => (
    axios.post('/api/profile/userinfo/disablesubscription/', { id, type })
      .then((response) => Promise.resolve(response.data))
  );
}
